/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.Administration {

    import fld = ConfigurationRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ConfigurationGrid extends _Ext.GridBase<ConfigurationRow, any> {
        protected getColumnsKey() { return 'Administration.Configuration'; }
        protected getDialogType() { return ConfigurationDialog; }
        protected getIdProperty() { return ConfigurationRow.idProperty; }
        protected getInsertPermission() { return ConfigurationRow.insertPermission; }
        protected getLocalTextPrefix() { return ConfigurationRow.localTextPrefix; }
        protected getService() { return ConfigurationService.baseUrl; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        private pendingChanges: Q.Dictionary<any> = {};

        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected getColumns() {
            var columns = super.getColumns();


            let SettingValueColumn = Q.first(columns, x => x.field == fld.Value);

            SettingValueColumn.format = ctx => {
                if (ctx.item.Type == 'String')
                    return this.stringInputFormatter(ctx);
                if (ctx.item.Type == 'Integer')
                    return this.numericInputFormatter(ctx);
                if (ctx.item.Type == 'Boolean')
                    return this.booleantFormatter(ctx);
                if (ctx.item.Type == 'Lookup') {
                    //
                    switch (ctx.item.Code) {
                        case 1002:
                            Q.reloadLookup("Config.Labour");
                            return this.selectFormatter(ctx, fld.Value, Q.getLookup("Config.Labour"));
                            break;
                        case 1003:
                            Q.reloadLookup("Config.StoneCosting");
                            return this.selectFormatter(ctx, fld.Value, Q.getLookup("Config.StoneCosting"));
                            break;
                        case 1028:
                            Q.reloadLookup("Config.StoneLabor");
                            return this.selectFormatter(ctx, fld.Value, Q.getLookup("Config.StoneLabor"));
                            break;
                        case 1038:
                            Q.reloadLookup("Config.LaborMarkup");
                            return this.selectFormatter(ctx, fld.Value, Q.getLookup("Config.LaborMarkup"));
                            break;
                        case 1039:
                            Q.reloadLookup("Config.StoneMarkUp");
                            return this.selectFormatter(ctx, fld.Value, Q.getLookup("Config.StoneMarkUp"));
                            break;
                        case 1040:
                            Q.reloadLookup("Config.MetalMarkUp");
                            return this.selectFormatter(ctx, fld.Value, Q.getLookup("Config.MetalMarkUp"));
                            break;
                        case 1047:
                            Q.reloadLookup("Config.SettingLabour");
                            return this.selectFormatter(ctx, fld.Value, Q.getLookup("Config.SettingLabour"));
                            break;
                    }

                } 
            }

            return columns;
        }

        protected getButtons() {
            var buttons = super.getButtons();

            buttons.push({
                title: 'Save Changes',
                cssClass: 'apply-changes-button disabled',
                onClick: e => this.saveClick(),
                separator: true
            });

            return buttons;
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            this.setSaveButtonState();
            return super.onViewProcessData(response);
        }

        private booleantFormatter(ctx) {
            var klass = 'edit check-box';
            var item = ctx.item as ConfigurationRow;
            var pending = this.pendingChanges[item.Id];

            if (pending && pending[ctx.column.field] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, ctx.column.field) as string;
            var check: string;
            var isChecked = q.ToBool(value);
            if (isChecked)
                check = "<input type='checkbox' checked='" + isChecked + "' class='" + klass +
                    "' data-field='" + ctx.column.field +
                    "' value='" + value + "'/>";
            else
                check = "<input type='checkbox' class='" + klass +
                    "' data-field='" + ctx.column.field +
                    "' value='" + value + "'/>";


            return check
        }

        private numericInputFormatter(ctx) {
            var klass = 'edit numeric';
            var item = ctx.item as ConfigurationRow;
            var pending = this.pendingChanges[item.Id];

            if (pending && pending[ctx.column.field] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, ctx.column.field) as number;
            var width = (ctx.column.width) as number - 10;

            return "<input type='text' style='width:" + width + "px;' class='" + klass +
                "' data-field='" + ctx.column.field +
                "' value='" + Q.formatNumber(value, '0.##') + "'/>";
        }

        private stringInputFormatter(ctx) {
            var klass = 'edit string';
            var item = ctx.item as ConfigurationRow;
            var pending = this.pendingChanges[item.Id];
            var column = ctx.column as Slick.Column;

            if (pending && pending[column.field] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, column.field) as string;
            var width = (ctx.column.width) as number - 10;

            return "<input type='text' style='width:" + width + "px;' class='" + klass +
                "' data-field='" + column.field +
                "' value='" + Q.attrEncode(value) +
                "' maxlength='" + column.sourceItem.maxLength + "'/>";
        }

        /**
         * Sorry but you cannot use LookupEditor, e.g. Select2 here, only possible is a SELECT element
         */
        private selectFormatter(ctx: Slick.FormatterContext, idField: string, lookup: Q.Lookup<any>) {

            var klass = 'edit';
            var item = ctx.item as ConfigurationRow;
            var pending = this.pendingChanges[item.Id];
            var column = ctx.column as Slick.Column;

            if (pending && pending[idField] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, idField);
            var markup = "<select class='" + klass +
                "' data-field='" + idField +
                "' style='width: 100%; max-width: 100%'>";
            for (var c of lookup.items) {
                let id = c[lookup.idField];
                markup += "<option value='" + Q.attrEncode(id) + "'"
                if (id == value) {
                    markup += " selected";
                }
                markup += ">" + Q.htmlEncode(c[lookup.textField]) + "</option>";
            }
            return markup + "</select>";
        }


        private getEffectiveValue(item, field): any {
            var pending = this.pendingChanges[item.Id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
           
            var pending = this.pendingChanges[item.Id];

            var effective = this.getEffectiveValue(item, field);
            var oldText: string;
            if (input.hasClass("numeric"))
                oldText = Q.formatNumber(effective, '0.##');
            else
                oldText = effective as string;

            var value;
            if (field === 'UnitPrice') {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass("numeric")) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else
                value = text;

            if (!pending) {
                this.pendingChanges[item.Id] = pending = {};
            }
            if (item.Type == "Boolean") {
                if (input.hasClass('check-box')) {
                    if (item.Value == "False") {
                        value = "True";
                        //input
                        input.prop("checked");
                    }
                    else {
                        value = "False";
                        input.prop("");
                    }
                }
            }

            pending[field] = value;
            item[field] = value;
            this.view.updateItem(item.Id, item);
            this.view.refresh();

            if (input.hasClass("numeric"))
                value = Q.formatNumber(value, '0.##');

            input.val(value).addClass('dirty');

            this.setSaveButtonState();
        }

        private setSaveButtonState() {
            this.toolbar.findButton('apply-changes-button').toggleClass('disabled',
                Object.keys(this.pendingChanges).length === 0);
        }

        private saveClick() {
            if (Object.keys(this.pendingChanges).length === 0) {
                return;
            }

            // this calls save service for all modified rows, one by one
            // you could write a batch update service
            var keys = Object.keys(this.pendingChanges);
            var current = -1;
            var self = this;

            (function saveNext() {
                if (++current >= keys.length) {
                    self.refresh();
                    return;
                }

                var key = keys[current];
                var entity = Q.deepClone(self.pendingChanges[key]);
                entity.Id = key;
                Q.serviceRequest('Administration/Configuration/Update', {
                    EntityId: key,
                    Entity: entity
                }, (response) => {
                    delete self.pendingChanges[key];
                    saveNext();
                });
            })();
        }


    }
}